import { render, staticRenderFns } from "./ProductEditSellPricesModalStartingPrice.vue?vue&type=template&id=70718616&scoped=true"
import script from "./ProductEditSellPricesModalStartingPrice.vue?vue&type=script&lang=ts"
export * from "./ProductEditSellPricesModalStartingPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70718616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70718616')) {
      api.createRecord('70718616', component.options)
    } else {
      api.reload('70718616', component.options)
    }
    module.hot.accept("./ProductEditSellPricesModalStartingPrice.vue?vue&type=template&id=70718616&scoped=true", function () {
      api.rerender('70718616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditSellPricesModalStartingPrice.vue"
export default component.exports